import { userLogout, useUserDispatch } from "../context"
import { useEffect } from "react"


export const LogoutPage = (props) => {
    const userDispatch = useUserDispatch()
    useEffect( ()=>{
        userLogout(userDispatch)
        .then(res=>{
            props.history.push("/")
        })
        .catch(error=>{
            props.history.goBack();
        })
    },[])
    
    return(
        <div className="appLoading">
            Logout in progress...
        </div>
    )
}